import { storePricings } from './../../../requests'

export const funcCreatePricings = async (resource, params) => {
  const { ...newData } = params.data
  const [, data] = await storePricings({ ...newData })
  return { data }
}
